import React from "react";
function FGGauge({value}) {
  const color=value>=70?"#ef4444":value>=55?"#f97316":value>=45?"#f59e0b":value>=30?"#22c55e":"#3b82f6";
  const label=value>=75?"극단적 탐욕":value>=55?"탐욕":value>=45?"중립":value>=25?"공포":"극단적 공포";
  const angle=(value/100)*180-90; const rad=angle*Math.PI/180;
  return (
    <div style={{textAlign:"center"}}>
      <svg viewBox="0 0 120 70" width="140" style={{display:"block",margin:"0 auto"}}>
        <path d="M10,60 A50,50 0 0,1 110,60" fill="none" stroke="#1e2433" strokeWidth="12" strokeLinecap="round"/>
        <path d="M10,60 A50,50 0 0,1 110,60" fill="none" stroke={color} strokeWidth="12" strokeLinecap="round"
          strokeDasharray={`${(value/100)*157} 157`}/>
        <line x1="60" y1="60" x2={60+35*Math.cos(rad)} y2={60+35*Math.sin(rad)} stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="60" cy="60" r="4" fill={color}/>
        <text x="60" y="46" textAnchor="middle" fill={color} fontSize="18" fontWeight="700">{value}</text>
      </svg>
      <p style={{color,fontWeight:700,fontSize:13,marginTop:2}}>{label}</p>
    </div>
  );
}
export default function SentimentPanel({ data }) {
  if (!data) return <p style={{color:"#6b7280"}}>데이터 없음</p>;
  const {fear_greed,social,positives=[],negatives=[]} = data;
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {fear_greed&&<FGGauge value={fear_greed.value}/>}
      {social&&(
        <div>
          <p style={{fontSize:12,color:"#6b7280",marginBottom:6}}>소셜 감성</p>
          <div style={{display:"flex",height:18,borderRadius:6,overflow:"hidden"}}>
            <div style={{width:`${(social.positive_ratio||0.5)*100}%`,background:"#22c55e",
              display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff"}}>
              {social.positive>0&&`👍 ${social.positive}`}
            </div>
            <div style={{flex:1,background:"#ef4444",display:"flex",alignItems:"center",justifyContent:"center",
              fontSize:10,fontWeight:700,color:"#fff"}}>
              {social.negative>0&&`👎 ${social.negative}`}
            </div>
          </div>
        </div>
      )}
      {positives.length>0&&(
        <div>
          <p style={{fontSize:12,color:"#22c55e",fontWeight:700,marginBottom:4}}>✅ 긍정 요인</p>
          <ul style={{paddingLeft:14,display:"flex",flexDirection:"column",gap:3}}>
            {positives.map((x,i)=><li key={i} style={{fontSize:12,color:"#d1fae5"}}>{x}</li>)}
          </ul>
        </div>
      )}
      {negatives.length>0&&(
        <div>
          <p style={{fontSize:12,color:"#ef4444",fontWeight:700,marginBottom:4}}>⚠️ 부정 요인</p>
          <ul style={{paddingLeft:14,display:"flex",flexDirection:"column",gap:3}}>
            {negatives.map((x,i)=><li key={i} style={{fontSize:12,color:"#fecaca"}}>{x}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
